import { Pressable, StyleSheet, Text, View } from 'react-native';
import { calcSizeForDevice, calcSizeForTv } from 'utils/index';

import { KeyboardAppearanceType } from './SimpleKeyboard';
import { KeyItemProps, NUMERIC_KEYBOARD } from './helpers/keyboardItems';

type NumericKeyboardProps = {
  onHandleKeyPress: (keyItem: KeyItemProps) => void;
  appearance?: KeyboardAppearanceType;
};

const KEYBOARD_LENGHT = NUMERIC_KEYBOARD.length;
const ITEM_SIZE = 52;
const GAP = 6;
const TOTAL_COLUMNS = 6;
const TOTAL_ROWS = Math.ceil(KEYBOARD_LENGHT / TOTAL_COLUMNS);

const NumericKeyboard: React.FC<NumericKeyboardProps> = ({
  onHandleKeyPress,
  appearance = 'default',
}) => {
  const backgroundColor =
    appearance === 'strong' ? 'rgba(6, 113, 224, 0.15)' : 'rgba(6, 113, 224, 0.07)';

  const getItemWidth = (columns?: number) => {
    const col = columns ?? 1;

    return calcSizeForTv(ITEM_SIZE * col + GAP * (col - 1));
  };

  return (
    <View style={styles.container}>
      {NUMERIC_KEYBOARD.map((keyItem, index) => (
        <View
          key={`${keyItem.item}-${index}`}
          style={{
            width: getItemWidth(keyItem.columns),
            marginRight: calcSizeForTv(GAP),
            marginBottom: calcSizeForTv(GAP),
          }}>
          <Pressable
            role="button"
            style={{
              ...styles.keyButton,
              backgroundColor,
              height: calcSizeForTv(ITEM_SIZE),
              justifyContent: 'center',
              alignItems: 'center',
            }}
            onPress={() => onHandleKeyPress(keyItem)}>
            <Text style={styles.keyText}>{keyItem.symbol}</Text>
          </Pressable>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: calcSizeForDevice(ITEM_SIZE * TOTAL_COLUMNS + GAP * TOTAL_COLUMNS),
    height: calcSizeForDevice(TOTAL_ROWS * ITEM_SIZE + (TOTAL_ROWS - 1) * GAP),
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  keyButton: {
    paddingHorizontal: 0,
    borderWidth: 1,
    borderColor: 'rgba(255, 255, 255, 0.2)',
    borderRadius: 2,
  },
  keyText: {
    fontSize: calcSizeForDevice(20),
    color: '#FFF',
  },
});

export default NumericKeyboard;
